export default () => ({
    london_eastern_and_south_east: 'London, Eastern and South East',
    midlands: 'Midlands',
    north_west: 'North West',
    northern: 'Northern',
    northern_ireland: 'Northern Ireland',
    republic_of_ireland: 'Republic of Ireland',
    scotland: 'Scotland',
    south_west: 'South West',
    wales: 'Wales',
    yorkshire_and_the_humber: 'Yorkshire and the Humber',
})